export const styles = {
  container: {
    p: 3,
  },
  title: {
    m: 0,
    mb: 1,
  },
};
